<template>
    <div class="relative text-base text-dark-light input-group" :class="class">
        <textarea 
            v-if="type == 'textarea'" 
            class="peer" 
            :name="name" 
            id="name" 
            placeholder=" " 
            rows="4"
            @input="$emit('update:modelValue', ($event.target as HTMLInputElement)?.value)"
            :required="required"
            v-bind="$attrs">{{ modelValue }}</textarea>
        <input 
            v-else-if="type == 'checkbox'" 
            type="checkbox" 
            class="peer ml-2 w-5 h-5 rounded-full border border-dark-light accent-primary dark:accent-primary-light transition" 
            :name="name" 
            :id="name" 
            value="1"
            :checked="modelValue == true"
            :required="required"
            @input="$emit('update:modelValue', ($event.target as HTMLInputElement)?.checked)"
            v-bind="$attrs" />
        <input 
            v-else 
            :type="type" 
            class="peer" 
            :name="name" 
            :id="name" 
            placeholder=" " 
            :value="modelValue"
            :required="required"
            @input="$emit('update:modelValue', ($event.target as HTMLInputElement)?.value)"
            v-bind="$attrs" />
        <label 
            v-if="type == 'checkbox'" 
            :for="name" 
            class="pl-2 peer-checked:text-primary dark:peer-checked:text-primary-light">{{ label }}<span v-if="required" class="text-sm text-accent pl-0.5">*</span></label>
        <label 
            v-else-if="type == 'textarea'"
            :for="name" 
            class="-translate-y-4 scale-90 top-2 left-1 z-10 origin-[0] bg-white dark:bg-zinc-800 px-2
                    peer-focus:text-primary dark:peer-focus:text-primary-light peer-focus:top-2 peer-focus:scale-90 peer-focus:-translate-y-4
                    peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-6 peer-placeholder-shown:text-dark-light 
                    ">{{ label }}<span v-if="required" class="text-sm text-accent pl-0.5">*</span></label>
        <label 
            v-else 
            :for="name" 
            class="-translate-y-4 scale-90 top-2 left-1 z-10 origin-[0] bg-white dark:bg-zinc-800 px-2
                    peer-focus:text-primary dark:peer-focus:text-primary-light peer-focus:top-2 peer-focus:scale-90 peer-focus:-translate-y-4
                    peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-placeholder-shown:text-dark-light 
                    ">{{ label }}<span v-if="required" class="text-sm text-accent pl-0.5">*</span></label>
    </div>
</template>
<script lang="ts">
// use normal <script> to declare options
export default {
    inheritAttrs: false,
};
</script>
<script setup lang="ts">
interface Props {
    type: string;
    name: string;
    label: string;
    required?: boolean;
    modelValue: string | boolean;
    class?: string;
}
withDefaults(defineProps<Props>(), {
    required: false
});
defineEmits(['update:modelValue'])
</script>

<style scoped>
  /* input */
  .input-group input:not([type=checkbox]), .input-group textarea {
    @apply block px-2.5 pb-2.5 pt-4 w-full xl:text-sm text-dark dark:text-zinc-200 bg-transparent rounded-lg border border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-primary dark:focus:border-primary-light focus:border;
  }
  .input-group label {
    @apply absolute xl:text-sm text-dark dark:text-zinc-400 transition-all duration-300 transform;
  }
</style>
